import { useState } from 'react'

import { Section } from '@factorialco/deprecated-design-system'
import {
  ProfileEmployeeLocationFragment,
  ProfileEmployeeLocationEmployeesLocationFragment,
} from 'generated/resources/graphql'

import { observer } from 'mobx-react'

import i18n from 'modules/core/lib/i18n'

import AssignWorkplacesModal from './AssignWorkplacesModal'
import EmployeeWorkplacesList from './EmployeeWorkplacesList'

interface WorkplacesProps {
  employeeId: number
  accessId: number
  employeeLocations: ProfileEmployeeLocationEmployeesLocationFragment[]
  companyLocations: ProfileEmployeeLocationFragment[]
  initialDefaultLocationId: number | null
  canAssignLocations: boolean
}

const WorkplacesInformation = ({
  employeeId,
  employeeLocations,
  companyLocations,
  accessId,
  initialDefaultLocationId,
  canAssignLocations,
}: WorkplacesProps) => {
  const [showAssignModal, setShowAssignModal] = useState(false)
  const [defaultLocationId, setDefaultLocationId] = useState<number | null>(
    initialDefaultLocationId
  )

  const openAssignWorkplaceModal = () => {
    setShowAssignModal(true)
  }

  const closeAssignWorkplaceModal = () => {
    setShowAssignModal(false)
  }

  return (
    <Section
      illustration="buildings"
      title={i18n.t('employee_form.workplaces.title')}
      description={i18n.t('employee_form.workplaces.info')}
      action={
        canAssignLocations
          ? {
              label: i18n.t('employee_form.workplaces.assign_workplaces'),
              onClick: openAssignWorkplaceModal,
            }
          : undefined
      }
    >
      <EmployeeWorkplacesList
        employeeId={employeeId}
        accessId={accessId}
        employeeLocations={employeeLocations}
        companyLocations={companyLocations}
        defaultLocationId={defaultLocationId}
        canAssignLocations={canAssignLocations}
        onDefaultLocationUpdated={(id) => setDefaultLocationId(id)}
      />

      {showAssignModal && companyLocations.length > 0 && (
        <AssignWorkplacesModal
          onCloseModal={closeAssignWorkplaceModal}
          employeeId={employeeId}
          employeeDefaultLocationId={defaultLocationId ?? -1}
          companyLocations={companyLocations}
          employeeLocations={employeeLocations}
        />
      )}
    </Section>
  )
}
export default observer(WorkplacesInformation)
